import type { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export const Play = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5 15L7 15L14 8L7 1L5 1L5 15Z" fill="currentColor" />
  </svg>
);
